import { CreateColumn } from '../../../Services/agGrid/createColumn';
import {
  POP_BASIC_DISPLAY_LAYER_OPTIONS,
  POP_BASIC_TYPE_OPTIONS,
  getPopBasicDisplayLayerLabel,
  getPopBasicTargetTypeLabel,
  getPopBasicTypeLabel,
} from './POP_BASIC_Schema';

const FormatYnCell = (params) => {
  const v = params.value;
  return v === true || v === 'Y' ? 'Y' : 'N';
};

const FormatDateTimeCell = (params) => {
  if (!params.value) return '';
  const d = new Date(params.value);
  if (Number.isNaN(d.getTime())) return String(params.value);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${min}`;
};

export const PopBasicTypeFilterItems = [
  { value: '', name: '전체' },
  ...POP_BASIC_TYPE_OPTIONS.map((o) => ({ value: o.value, name: o.label })),
];

export const PopBasicDisplayLayerFilterItems = [
  { value: '', name: '전체' },
  ...POP_BASIC_DISPLAY_LAYER_OPTIONS.map((o) => ({ value: o.value, name: o.label })),
];

export const PopBasicUseYnFilterItems = [
  { value: '', name: '전체' },
  { value: 'Y', name: '사용' },
  { value: 'N', name: '미사용' },
];

/** POP_BASIC 목록 그리드 */
export const GetColumnDefs1 = () => [
  {
    field: 'selectRow',
    headerName: '',
    width: 56,
    minWidth: 56,
    maxWidth: 56,
    pinned: 'left',
    sortable: false,
    filter: false,
    editable: false,
    resizable: false,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  CreateColumn('popTypeNm', '팝업 유형', 'center', 140, false, false, false, 'text', {
    minWidth: 130,
    valueGetter: (params) =>
      params.data?.popTypeNm ?? getPopBasicTypeLabel(params.data?.popType),
  }),
  CreateColumn('title', '제목', 'left', 200, false, false, false, 'text', {
    flex: 1,
    minWidth: 160,
  }),
  CreateColumn(
    'targetTypeNm',
    '노출 대상',
    'center',
    120,
    false,
    false,
    false,
    'text',
    {
      minWidth: 110,
      valueGetter: (params) =>
        params.data?.targetTypeNm ??
        getPopBasicTargetTypeLabel(params.data?.targetType),
    }
  ),
  CreateColumn(
    'displayLayerNm',
    '노출 형태',
    'center',
    120,
    false,
    false,
    false,
    'text',
    {
      minWidth: 110,
      valueGetter: (params) =>
        params.data?.displayLayerNm ??
        getPopBasicDisplayLayerLabel(params.data?.displayLayer),
    }
  ),
  CreateColumn(
    'dispStartDt',
    '노출 시작',
    'center',
    140,
    false,
    false,
    false,
    'text',
    {
      minWidth: 130,
      valueFormatter: FormatDateTimeCell,
    }
  ),
  CreateColumn(
    'dispEndDt',
    '노출 종료',
    'center',
    140,
    false,
    false,
    false,
    'text',
    {
      minWidth: 130,
      valueFormatter: FormatDateTimeCell,
    }
  ),
  CreateColumn(
    'dispPriority',
    '우선순위',
    'center',
    110,
    false,
    false,
    false,
    'text',
    {
      maxWidth: 110,
    }
  ),
  CreateColumn(
    'isForceClose',
    '강제확인',
    'center',
    110,
    false,
    false,
    false,
    'text',
    {
      maxWidth: 110,
      valueFormatter: FormatYnCell,
    }
  ),
  CreateColumn(
    'isHideToday',
    '오늘 하루\n보지 않기',
    'center',
    110,
    false,
    false,
    false,
    'text',
    {
      maxWidth: 120,
      wrapHeaderText: true,
      headerClass: 'ag-header-cell-wrap',
      valueFormatter: FormatYnCell,
    }
  ),
  CreateColumn('useYn', '사용', 'center', 72, false, false, false, 'text', {
    maxWidth: 80,
    valueFormatter: FormatYnCell,
  }),
  CreateColumn('createId', '등록자', 'center', 100, false, false, false, 'text', {
    minWidth: 90,
  }),
  CreateColumn(
    'createDate',
    '등록일시',
    'center',
    140,
    false,
    false,
    false,
    'text',
    {
      minWidth: 130,
      valueFormatter: FormatDateTimeCell,
    }
  ),
  CreateColumn('popId', '팝업ID', 'center', 90, false, false, true, 'text'),
];
